import React, { useEffect, useState } from "react";
import { IzobrazevanjeFormType } from "../../types/Izobrazevanje/IzobrazevanjeFormType";
import Button from "../../components/Common/Button";
import FormActions from "../../components/Form/FormActions";
import FormContainer from "../../components/Form/FormContainer";
import FormItems from "../../components/Form/FormItems";
import { IzobrazevanjeTipListType } from "../../types/IzobrazevanjeTip/IzobrazevanjeTipListType";
import Nullable from "../../types/Nullable";
import { PodrocjeFormType } from "../../types/Podrocje/PodrocjeFormType";
import { Link, useNavigate } from "react-router-dom";
import ApiException from "../../types/ApiException";
import TextInput from "../../components/Form/TextInput";
import DropdownInput from "../../components/Form/DropdownInput";
import TextArea from "../../components/Form/TextArea";
import DateRange from "../../components/Form/DateRange";
import CheckboxInput from "../../components/Form/CheckboxInput";
import CheckboxItem from "../../components/Form/CheckboxItem";
import Modal from "../../components/Common/Modal";
import { DokumentVrsta, IzobrazevanjeStatus } from "../../utils/Enums";
//import FileUpload from "../../components/Common/FileUpload";
import FileUploadField from "../../components/Form/FileUploadField";
import RadioItem from "../../components/Form/RadioItem";
import RadioInput from "../../components/Form/RadioInput";
import { getPathWithBaseURL } from "../../utils/Common";
import useUploadIzobrazevanjeDokument from "../dokument/DokumentHooks";
import getApiExceptionObjectFromAxiosError from "../../utils/ProcessException";
import { AxiosResponse } from "axios";

type IzobrazevanjeFormArgs<T> = {
    izobrazevanje: IzobrazevanjeFormType;
    izobrazevanjeTipi: IzobrazevanjeTipListType[];
    podrocja: Nullable<PodrocjeFormType[]>;
    onSaveDraft: (izobrazevanje: IzobrazevanjeFormType, onSuccessCallback?: (izobrazevanje: IzobrazevanjeFormType) => Promise<void>) => void;
    onSavePublish?: (izobrazevanje: IzobrazevanjeFormType, onSuccessCallback?: (izobrazevanje: IzobrazevanjeFormType) => Promise<void>) => void;
    onDelete?: (izobrazevanje: IzobrazevanjeFormType) => void;
    onECourseToActive?: (izobrazevanjeId: number) => void;
    onECourseToDraft?: (izobrazevanjeId: number) => void;
    apiException: ApiException | null;
}

const IzobrazevanjeForm = <T,>({ izobrazevanje, izobrazevanjeTipi, podrocja, onSaveDraft, onSavePublish, onDelete, apiException }: IzobrazevanjeFormArgs<T>) => {
    const [izobrazevanjeState, setIzobrazevanjeState] = useState({ ...izobrazevanje });
    //const [slikaDokument, setSlikaDokument] = useState<File | null>();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [lokacijaUrlError, setLokacijaUrlError] = useState<string | null>(null);
    const [isSlikaChanged, setIsSlikaChanged] = useState(false);
    const uploadIzobrazevanjeDokument = useUploadIzobrazevanjeDokument();
    
//console.log("izobrazevanjeState.izobrazevanjeId", izobrazevanjeState.izobrazevanjeId);

    const nav = useNavigate();

    const onSuccessCallback = async (izobrazevanje: IzobrazevanjeFormType) => {
        console.log("Draft saved successfully!");
        console.log("Izobrazevanje:", izobrazevanje.izobrazevanjeId);
        setIzobrazevanjeState(s => ({ ...s, izobrazevanjeId: izobrazevanje.izobrazevanjeId, eCourseSkupinaId: izobrazevanje.eCourseSkupinaId })); // keep the client state after the first save (correctly selects radio button eampus)
        //setIzobrazevanjeState(izobrazevanje); // keep the client state after the first save (correctly selects radio button eampus)
        await uploadSlika(izobrazevanje.izobrazevanjeId);
    };

    const onSubmitDraft: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
        e.preventDefault();
        setLokacijaUrlError(null);
        onSaveDraft(izobrazevanjeState, onSuccessCallback);
    }

    const onSubmitPublish: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
        if (onSavePublish) {
            e.preventDefault();
            setLokacijaUrlError(null);
            onSavePublish(izobrazevanjeState, onSuccessCallback);
        }
    }

    // const onSubmitDraft: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    //     e.preventDefault();
    //     onIzobrazevanjeMutatiedDraft.mutate(izobrazevanjeState, {
    //         onSuccess:(newIzobrazevanjeId: AxiosResponse) => {
    //             if(newIzobrazevanjeId){
    //                 console.log("newIzobrazevanjeId", newIzobrazevanjeId);
    //                 //setIzobrazevanjeState({ ...izobrazevanjeState, izobrazevanjeId: newIzobrazevanjeId.data as number });
    //                 setIzobrazevanjeState((prevState) => ({
    //                     ...prevState,
    //                     izobrazevanjeId: newIzobrazevanjeId.data as number
    //                 }));
    //                 console.log("after newIzobrazevanjeId - izobrazevanjeState.izobrazevanjeId", izobrazevanjeState.izobrazevanjeId);
    //             }
    //             uploadSlika();
    //         }
    //     });
    // }

    // const onSubmitPublish: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    //     e.preventDefault();
    //     onIzobrazevanjeMutatiedPublish.mutate(izobrazevanjeState, {
    //         onSuccess:() =>{
    //             uploadSlika();
    //         }
    //     });
    // }

    const showModal: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
        e.preventDefault();
        setShowDeleteModal(true);
    }

    const onDeleteConfirm: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
        if (onDelete){
            e.preventDefault();
            onDelete(izobrazevanjeState);
        }
    }

    const onThumbnailChange = (file: File | null) => {
        setIzobrazevanjeState({
            ...izobrazevanjeState,
            slikaDokument: file == null ? null : izobrazevanjeState.slikaDokument,
            slika: file
        });
        //setSlikaDokument(file);
        setIsSlikaChanged(true);
    };
    
    const isEdit = Boolean(izobrazevanjeState.izobrazevanjeId);     // → true if the record already exists
    // TODO: samo če je shranjeno stanje lokacije 3 je readonly lokacija
    const lokacijaLocked = isEdit && izobrazevanje.lokacijaVrsta === 3;

    async function uploadSlika(izobrazevanjeId: number) {
        console.log("uploadThumbnail");
        if (!isSlikaChanged)
            return;

        console.log("in uploadSlika - izobrazevanjeState.izobrazevanjeId", izobrazevanjeState.izobrazevanjeId);

        await uploadIzobrazevanjeDokument.mutateAsync({
            dokument: izobrazevanjeState.slika ?? null,
            izobrazevanjeId: izobrazevanjeId,
            vrsta: DokumentVrsta.Thumbnail
        }, {
            onSuccess:()=>{
                setIsSlikaChanged(false);
                //setSlikaDokument(null); // ?
            }
        });
    }

    // function uploadSlika() {
    //     console.log("uploadThumbnail");
    //     if (!isSlikaChanged)
    //         return;

    //     console.log("in uploadSlika - izobrazevanjeState.izobrazevanjeId", izobrazevanjeState.izobrazevanjeId);

    //     uploadIzobrazevanjeDokument.mutate({
    //         dokument: slikaDokument ?? null,
    //         izobrazevanjeId: izobrazevanjeState.izobrazevanjeId,
    //         vrsta: DokumentVrsta.Thumbnail
    //     }, {
    //         onSuccess:()=>{
    //             setIsSlikaChanged(false);
    //             setSlikaDokument(null); // ?
    //         }
    //     });
    // }

    function setPodrocja(e: React.ChangeEvent<HTMLInputElement>, all = false): void {
        if (all) {
            if (e.target.checked) {
                setIzobrazevanjeState({ ...izobrazevanjeState, podrocjaIds: podrocja!.map(x => x.podrocjeId) })
            } else {
                setIzobrazevanjeState({ ...izobrazevanjeState, podrocjaIds: [] })
            }
        } else {
            if (e.target.checked)
                setIzobrazevanjeState({ ...izobrazevanjeState, podrocjaIds: izobrazevanjeState.podrocjaIds.concat(Number(e.target.value)) })
            else if (izobrazevanjeState.podrocjaIds.includes(Number(e.target.value)))
                setIzobrazevanjeState({ ...izobrazevanjeState, podrocjaIds: izobrazevanjeState.podrocjaIds.filter(pi => pi !== Number(e.target.value)) })
        }
    }

    function setSelectIzobrazevanjeTipId(e: React.ChangeEvent<HTMLSelectElement>) {
        const it = izobrazevanjeTipi.filter(it => it.izobrazevanjeTipId === Number(e.target.value))[0];
        setIzobrazevanjeState({
            ...izobrazevanjeState,
            izobrazevanjeTipId: Number(e.target.value),
            tockeSt: it.stTockPrivzeto,
            udelezenciSt: izobrazevanjeState.prijavaOmejena ? it.stMestPrivzeto : null
        })
    }

    function setUdelezenciSt(e: React.ChangeEvent<HTMLInputElement>) {
        const it = izobrazevanjeTipi.filter(it => it.izobrazevanjeTipId === Number(izobrazevanjeState.izobrazevanjeTipId))[0];
        setIzobrazevanjeState({
            ...izobrazevanjeState,
            prijavaOmejena: e.target.checked,
            udelezenciSt: e.target.checked ? it.stMestPrivzeto : null
        })
    }

    return (
        <FormContainer>
            <Modal
                visible={showDeleteModal}
                message="Ali ste prepričani da želite izbrisati to izobraževanje?"
                actionMessage="izbriši"
                actionIcon="delete"
                onCancel={() => setShowDeleteModal(false)}
                onConfirm={onDeleteConfirm}
            />            
            <FormActions>
                <Button startIcon="arrow_back_ios" onClick={() => nav('/izobrazevanje/list')}>nazaj na seznam</Button>
                <Button className="right" onClick={onSubmitPublish} startIcon="done" tertiary>objavi</Button>
            </FormActions>
            <FormItems labelsWidth="27%">
                <TextInput
                    value={izobrazevanjeState.naziv}
                    width="350px"
                    placeholder="Naziv"
                    label="Naziv izobraževanja"
                    required={true}
                    err={apiException}
                    errField="Naziv"
                    onChange={(e) => setIzobrazevanjeState({ ...izobrazevanjeState, naziv: e.target.value })}
                />
                <FileUploadField
                    label="Slika"
                    required
                    /* show “remove” when either a new file or an existing DB file is present */
                    value={izobrazevanjeState.slika ?? (izobrazevanjeState.slikaDokument ? new File([], "") : null)}

                    chooseButtonText={
                        izobrazevanjeState.slika || izobrazevanjeState.slikaDokument
                        ? "Zamenjaj sliko"
                        : "Izberi sliko"
                    }
                    removeButtonText="Odstrani sliko"
                    acceptedFileTypes="image/*"
                    onFileChange={onThumbnailChange}
                    startIcon="upload"
                    tertiary
                    className="izobrazevanjeUploadBtn"
                    removeButtonClassName="izobrazevanjeRemoveBtn"
                    err={apiException}
                    errField="SlikaDokument"
                    />
                {((izobrazevanjeState.slika || izobrazevanjeState.slikaDokument) 
                    && <img src={izobrazevanjeState.slika ? 
                    URL.createObjectURL(izobrazevanjeState.slika) 
                    : izobrazevanjeState.slikaDokument ?
                        getPathWithBaseURL(izobrazevanjeState.slikaDokument.webLink) 
                        : ""} alt="thumbnail" height="150px" className="izobrazevanjeFilePreview"/>
                )}
                <TextInput
                    value={izobrazevanjeState.predavatelj ? izobrazevanjeState.predavatelj : ""}
                    width="350px"
                    placeholder="Predavatelj"
                    label="Predavatelj"
                    required={false}
                    err={apiException}
                    errField="Predavatelj"
                    onChange={(e) => setIzobrazevanjeState({ ...izobrazevanjeState, predavatelj: e.target.value })}
                />
                <DateRange
                    label="Datum od/do"
                    odValue={izobrazevanjeState.datumCasOd ? new Date(izobrazevanjeState.datumCasOd) : null}
                    doValue={izobrazevanjeState.datumCasDo ? new Date(izobrazevanjeState.datumCasDo) : null}
                    odOnChange={function (date: Date | null | undefined) {   
                        setIzobrazevanjeState({ ...izobrazevanjeState, datumCasOd: date ? new Date(date) : null })
                    }}
                    err={apiException}
                    errField="DatumCasOd"
                    doOnChange={function (date: Date | null | undefined) {
                        setIzobrazevanjeState({ ...izobrazevanjeState, datumCasDo: date ? new Date(date) : null })                     
                    }}
                />
                <TextArea
                    width="350px"
                    height="100px"
                    label="Opis"
                    placeholder="Opis"
                    value={izobrazevanjeState.opis ? izobrazevanjeState.opis : ""}
                    onChange={(e) => setIzobrazevanjeState({ ...izobrazevanjeState, opis: e.target.value })}
                    required={false}
                />
                <DropdownInput
                    label="Kategorija"
                    value={izobrazevanjeState.izobrazevanjeTipId}
                    onChange={(e) => setSelectIzobrazevanjeTipId(e)}
                    required={true}
                >
                    {izobrazevanjeTipi && izobrazevanjeTipi.map((it) => (
                        <option key={it.izobrazevanjeTipId} value={it.izobrazevanjeTipId}>{it.naziv}</option>
                    ))}
                </DropdownInput>
                <TextInput
                    label="Št. točk"
                    placeholder="0"
                    type="number"
                    isWholeNumber
                    width="100px"
                    min={0}
                    value={izobrazevanjeState.tockeSt == null ? "" : izobrazevanjeState.tockeSt}
                    onChange={(e) => setIzobrazevanjeState({ ...izobrazevanjeState, tockeSt: Number(e.target.value) })}
                    err={apiException}
                    errField={"TockeSt"}
                />
                <CheckboxInput label="Na voljo za" err={apiException} errField={"PodrocjaIds"}>
                    {podrocja && podrocja.map((p) => (
                        <CheckboxItem
                            key={p.podrocjeId}
                            id={`p_${p.podrocjeId}`}
                            value={p.podrocjeId}
                            name={`p_${p.podrocjeId}`}
                            checked={izobrazevanjeState.podrocjaIds && izobrazevanjeState.podrocjaIds.includes(p.podrocjeId)}
                            onChange={(e) => setPodrocja(e)}
                            label={p.naziv}
                        />
                    ))}
                    <CheckboxItem
                        key={0}
                        id={'izberi vse'}
                        value={'izberi vse'}
                        name={'izberi vse'}
                        checked={izobrazevanjeState.podrocjaIds && izobrazevanjeState.podrocjaIds.length === podrocja?.length}
                        onChange={(e) => setPodrocja(e, true)}
                        label={'izberi vse'}
                    />
                </CheckboxInput>
                <CheckboxInput label="Omejitev prijav" errField="OmejitevPrijav">
                    <CheckboxItem
                        value="omejitevPrijav"
                        name="omejitevPrijav"
                        checked={!!izobrazevanjeState.prijavaOmejena}
                        onChange={(e) => setUdelezenciSt(e)}
                    />
                </CheckboxInput>
                {izobrazevanjeState.prijavaOmejena &&
                    <TextInput
                        width="100px"
                        label="Št. udeležencev"
                        placeholder="0"
                        type="number"
                        isWholeNumber
                        min={0}
                        value={izobrazevanjeState.udelezenciSt == null ? "" : izobrazevanjeState.udelezenciSt}
                        onChange={(e) => setIzobrazevanjeState({ ...izobrazevanjeState, udelezenciSt: Number(e.target.value) })}
                        err={apiException}
                        errField="UdelezenciSt"
                        required={true}
                    />
                }
                {/*
                <TextInput
                    label="Lokacija"
                    placeholder="Lokcija enum"
                    type="number"
                    isWholeNumber
                    width="100px"
                    min={1}
                    max={3}
                    value={izobrazevanjeState.lokacijaVrsta == null ? "3" : izobrazevanjeState.lokacijaVrsta}
                    onChange={(e) => setIzobrazevanjeState({ ...izobrazevanjeState, lokacijaVrsta: Number(e.target.value) })}
                    err={apiException}
                    errField={"LokacijaVrsta"}
                />
                */}
                <RadioItem
                    label="Lokacija"
                    required
                    err={apiException}
                    errField="LokacijaVrsta"
                    >
                    <fieldset disabled={lokacijaLocked} style={{border: 0, padding: 0, margin: 0}}>
                        <RadioInput
                            name="lokacijaVrsta"
                            value={3}
                            label="eCampus (samodejno)"
                            checked={(izobrazevanjeState.lokacijaVrsta) === 3}
                            onChange={(e) =>
                            setIzobrazevanjeState({
                                ...izobrazevanjeState,
                                lokacijaVrsta: Number(e.target.value),
                            })
                            }
                        />
                        
                        <RadioInput
                            name="lokacijaVrsta"
                            value={1}
                            label="spletna povezava"
                            checked={izobrazevanjeState.lokacijaVrsta === 1}
                            onChange={(e) =>
                            setIzobrazevanjeState({
                                ...izobrazevanjeState,
                                lokacijaVrsta: Number(e.target.value),
                            })
                            }
                        />
                        <RadioInput
                            name="lokacijaVrsta"
                            value={2}
                            label="fizična lokacija"
                            checked={izobrazevanjeState.lokacijaVrsta === 2}
                            onChange={(e) =>
                            setIzobrazevanjeState({
                                ...izobrazevanjeState,
                                lokacijaVrsta: Number(e.target.value),
                            })
                            }
                        />
                    </fieldset>
                    {izobrazevanje.lokacijaVrsta === 3 && <a href={izobrazevanjeState.eCourseURL || ""} target="_blank" rel="noreferrer" className="link">
                        vstopi v e-učilnico
                    </a>}
                </RadioItem>
                {/* Lokacija dodatno – shown only for 1 or 2 */}
                {(izobrazevanjeState.lokacijaVrsta ?? 3) === 1 && (
                    <>
                        <TextInput
                            label="Lokacija dodatno"
                            placeholder="Lokacija dodatno"
                            value={izobrazevanjeState.lokacijaPodrobnosti == null ? "" : izobrazevanjeState.lokacijaPodrobnosti}
                            onChange={(e) => {
                                const val = e.target.value;
                                try {
                                    new URL(val);
                                    setLokacijaUrlError(null);
                                } catch {
                                    setLokacijaUrlError("Neveljaven URL (npr. https://www.primer.si)");
                                }
                                setIzobrazevanjeState({ ...izobrazevanjeState, lokacijaPodrobnosti: val });
                            }}
                            err={apiException}
                            errField={"LokacijaPodrobnosti"}
                        />
                        {lokacijaUrlError && <span className="error red">{lokacijaUrlError}</span>}
                    </>
                )}
                {(izobrazevanjeState.lokacijaVrsta ?? 3) === 2 && (
                    <TextArea
                        width="350px"
                        height="100px"
                        label="Lokacija dodatno"
                        placeholder="Lokacija dodatno"
                        value={izobrazevanjeState.lokacijaPodrobnosti == null ? "" : izobrazevanjeState.lokacijaPodrobnosti}
                        onChange={(e) => { setIzobrazevanjeState({ ...izobrazevanjeState, lokacijaPodrobnosti: e.target.value })}}
                        required={false}
                    />
                )}
                {/* <TextInput
                    label="Povezava"
                    type="text"
                    width="350px"
                    value={izobrazevanjeState.povezava ? izobrazevanjeState.povezava : ""}
                    onChange={(e) => setIzobrazevanjeState({ ...izobrazevanjeState, povezava: e.target.value })}
                    err={apiException}
                    errField="Povezava"
                /> */}
            </FormItems>
            <FormActions>
                {izobrazevanjeState.status == IzobrazevanjeStatus.VPripravi &&
                    <Button onClick={showModal} startIcon="delete" tertiary>izbriši</Button>
                }
                <div></div>
                <div className="right">
                    <Button onClick={onSubmitDraft} startIcon="save" primary>shrani</Button>
                    <Link to={`/izobrazevanje/list`}>
                        <Button startIcon="close" cancel>prekliči</Button>
                    </Link>
                </div>
            </FormActions>
        </FormContainer>
    );
}

export default IzobrazevanjeForm;